import { render, staticRenderFns } from "./PoligonoSvg.vue?vue&type=template&id=2031e07b&scoped=true"
import script from "./PoligonoSvg.vue?vue&type=script&lang=js"
export * from "./PoligonoSvg.vue?vue&type=script&lang=js"
import style0 from "./PoligonoSvg.vue?vue&type=style&index=0&id=2031e07b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2031e07b",
  null
  
)

export default component.exports